/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_SERVER, API_SCT, API_UPLOADS } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(false);
    const [file, set_file] = useState(null);
    const [element, set_element] = useState(null);
    const [pagination_active, set_pagination_active] = useState(1);
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');

    const [id, set_id] = useState('');
    const [video, set_video] = useState('');
    const [title, set_title] = useState('');
    const [description, set_description] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (20 * pages) - 20 : 0
        
        }
        
        loading(true);

        API_GET_REQUEST('web__________?action=read_video'
            + '&limit=20'
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                console.log(JSON.stringify(response.data.data, undefined, 2))
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _insert = () => {

		if(loading === true){
            return
        }

        loading(true);

        API_GET_REQUEST('web__________?action=insert_video'
            + '&video=' + video
            + '&title=' + title
            + '&description=' + description
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                console.log(JSON.stringify(response.data.data, undefined, 2))
                set_refresh(random_character(16))
                set_element(null)
                set_title('')
                set_video('')
                set_description('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _delete = (id) => {

		if(loading === true){
            return
        }

        loading(true);

        API_GET_REQUEST('web__________?action=delete_video'
            + '&id=' + id
            + '&video=' + video
            + '&title=' + title
            + '&description=' + description
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                console.log(JSON.stringify(response.data.data, undefined, 2))
                set_refresh(random_character(16))
                set_element(null)
                set_title('')
                set_video('')
                set_description('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _update = (id) => {

		if(loading === true){
            return
        }

        loading(true);

        API_GET_REQUEST('web__________?action=update_video'
            + '&id=' + id
            + '&video=' + video
            + '&title=' + title
            + '&description=' + description
        , 
		).then((response) => {
            if(response.data.result == 'success'){
                console.log(JSON.stringify(response.data.data, undefined, 2))
                set_refresh(random_character(16))
                set_element(null)
                set_title('')
                set_video('')
                set_description('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {
        
        if(search.length > 3){
    
            API_GET_REQUEST('source__________?action=search'
                + '&search=' + search
            , 
            ).then((response) => {
                if(response.data.result == 'success'){
                    // console.log(JSON.stringify(response.data.data.list, undefined, 2))
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console.log('catch : ', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = () => {

        let action;

        if(file === null){
            action = 'text'
        }else{
            if(element === 'overlay'){
                action = 'file_add'
            }else{
                action = 'file'
            }
        }

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("action", action);
        data.append("id", id);
        data.append("video", video);
        data.append("title", title);
        data.append("description", description);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_SERVER + "/api/v1.0/web/services__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(action !== 'text'){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            if(response.data.result === 'success'){
                console.log('results : ', JSON.stringify(response.data));
                set_file(null)
                set_refresh(random_character(16))
                set_element(null)
                set_title('')
                set_video('')
                set_description('')
                error(response.data.title)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _read()
        }

    }, [refresh, search])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>Web Video</h1>
                </div>
            </div>
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian Video web</p>
            </div>

            <div className="_row _center_align">
                <div className="_column">
                    <div className="_font_size_20px _push_b_d _push_t_d">Video</div>
                </div>
                <div>                    
                    <div onClick={() => {
                        set_element('overlay')
                    }} className="_btn _cursor_pointer">
                        Tambah
                    </div>
                </div>
            </div>

            {
                element === 'overlay' ?
                    <>
                        <div className="_fmc_overlay" style={{position: 'relative', borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', marginBottom: 20}}>
                            <div className="_fmc_overlay_navbar">
                                <div className="_row _center_align">
                                    <div className="_column">
                                        <p className="_font_size_18px">Uploads</p>
                                    </div>
                                    <div onClick={() => {
                                        if(element === 'overlay'){
                                            set_element(null)
                                        }else{
                                            set_element('overlay')
                                        }
                                    }} className="_push_l_d _btn _cursor_pointer">
                                        Keluar
                                    </div>
                                </div>
                            </div>
                            <div className="_fmc_overlay_content">

                                <div>
                                    <div className="_push_b_m">
                                        <div className="_relative _push_b_m">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Video Url
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_video(e.target.value)}
                                                    value={video}
                                                />
                                            </div>
                                        </div>
                                        <small>Masukan url</small>
                                    </div>
                                    <div className="_push_b_m">
                                        <div className="_relative _push_b_m">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Title
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_title(e.target.value)}
                                                    value={title}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_push_b_m">
                                        <div className="_relative _push_b_m">
                                            <p style={{color: '#888', fontSize: 13}}>
                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                Description
                                            </p>
                                            <div className="_e_input">
                                                <input 
                                                    placeholder=""
                                                    type={'text'} 
                                                    onChange={e => set_description(e.target.value)}
                                                    value={description}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div>                    
                                        <div onClick={() => {
                                            _insert()
                                        }} className="_btn _cursor_pointer">
                                            Simpan
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                : null
            }

            <div className="_overflow_x">
                <table className="_table">
                    <thead>
                        <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                        <th>Video</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>
                            <div className="_right_text">
                                <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                            </div>
                        </th>
                    </thead>
                    <tbody>
                        {
                            data && data.list.map((item, index) => (
                                <>
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <a href={item.video} target="_black">
                                                <ion-icon name="aperture-outline" style={{fontSize: 18}}></ion-icon>
                                            </a>
                                        </td>
                                        <td>
                                            {item.title}
                                        </td>
                                        <td>
                                            {item.description}
                                        </td>
                                        <td>
                                            <div className="_right_text _push_r_m">
                                                <div onClick={() => {
                                                    if(element === `update_${index}`){
                                                        set_element(null)
                                                    }else{
                                                        set_element(`update_${index}`)
                                                        set_id(item.id)
                                                        set_video(item.video)
                                                        set_title(item.title)
                                                        set_description(item.description)
                                                    }
                                                }} className="_btn _cursor_pointer _push_r_m">
                                                    Update
                                                </div>
                                                <div onClick={() => {
                                                    _delete(item.id)
                                                }} className="_btn _cursor_pointer">
                                                    Delete
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    {
                                        element === `update_${index}` &&
                                        <tr style={{verticalAlign: 'top'}}>
                                            <td></td>
                                            <td>
                                                <div className="_relative _push_b_m">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Video Url
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_video(e.target.value)}
                                                            value={video}
                                                        />
                                                    </div>
                                                </div>
                                                <small>Masukan Url</small>
                                            </td>
                                            <td>
                                                <div className="_relative _push_b_m">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Title
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_title(e.target.value)}
                                                            value={title}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_relative _push_b_m">
                                                    <p style={{color: '#888', fontSize: 13}}>
                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                        Description
                                                    </p>
                                                    <div className="_e_input">
                                                        <input 
                                                            placeholder=""
                                                            type={'text'} 
                                                            onChange={e => set_description(e.target.value)}
                                                            value={description}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="_right_text _push_r_m">
                                                    <div onClick={() => {
                                                        _update(item.id)
                                                    }} className="_btn _cursor_pointer">
                                                        Simpan
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </>
                            ))
                        }
                    </tbody>
                </table>
            </div>

            {/* <div className="_row _center_align">
                <div className="_column">

                </div>
                <div className="_column">
                    
                </div>
            </div> */}
            
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>

            <div style={{height: 100}}></div>

        </>
    );

}

export default Screen;